import { VIDEO_POPUP_SIZE } from './constants'

export const defaultState = {
  opened: false,
  videoUrl: '',
  size: VIDEO_POPUP_SIZE.small,
  autoplay: true
}

const reducer = (state = defaultState, action) => {
  if (action.type === 'OPEN_VIDEO_POPUP') {
    return {
      opened: true,
      size: action.size,
      videoUrl: action.videoUrl,
      autoplay: action.autoplay
    }
  }

  if (action.type === 'CLOSE_VIDEO_POPUP') {
    return {
      opened: false,
      size: VIDEO_POPUP_SIZE.small,
      videoUrl: '',
      autoplay: true
    }
  }

  return state
}

export default reducer
